import { TextInput, TextInputProps } from '@mantine/core';
import { useDebouncedCallback } from '@mantine/hooks';
import { ChangeEvent, useEffect, useState } from 'react';

import { ContainsFilter } from '../../data-access/types/filters';

import { useColFilter } from '@data-access';

type ContainsFilterProps = {
  filter: ContainsFilter;
  name: string;
};

export const ContainsFilterComponent = ({
  filter,
  name,
}: ContainsFilterProps) => {
  const [filterValue, setFilter] = useColFilter('orders', name);
  const [value, setValue] = useState(filterValue || '');

  const handleSearch = useDebouncedCallback((query: string) => {
    setFilter(query);
  }, 300);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue(event.currentTarget.value);
    handleSearch(event.currentTarget.value);
  };

  useEffect(() => {
    // when filterValue is reset from outside, reset the local value too
    if (!filterValue) {
      setValue('');
    }
  }, [filterValue]);

  return (
    <TextInput
      label={filter.label}
      onChange={handleChange}
      placeholder={filter.label}
      value={value as string | undefined}
    />
  );
};
